import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ReportTemplateRedirect = () => {
  const location = useLocation();
  const id = location.state?.id;
  if (!id) {
    return <Navigate to="/reports-dashboard" replace />;
  }
  return (
    <Navigate
      to={`/reports-dashboard/${id}${location.search || ''}`}
      replace
      state={location.state}
    />
  );
};

export default ReportTemplateRedirect;
